import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

const GrHeader = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            current: PropTypes.number,
            content: PropTypes.array,
        };
        render() {
            const { content, current } = this.props;
            const herderDiv = content.map((item, index) => {
                if (index === this.props.current) {
                    return (
                        <li key={index} className={styles.current}>
                            <a href={item.url}>{item.title}</a>
                        </li>
                    );
                } else {
                    return (
                        <li key={index}>
                            <a href={item.url}>{item.title}</a>
                        </li>
                    );
                }
            });

            return (
                <div className={styles.xy_head}>
                    <div className={styles.col_w1000}>
                        <div className={styles.zp_logo_mt15}>
                            <img src="http://p0.ifengimg.com/fe/fh_recruit/images/logo_07b3b3f3.png" alt="" />
                        </div>
                        <div className={styles.nav_xz}>
                            <ul>{herderDiv}</ul>
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export { GrHeader };
export default GrHeader;
